<template>
  <div class="error-container">
    <ul id="example-1">
      <li>
        {{ error }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Error-Messages',
  props: ['error']
}
</script>



// WEBPACK FOOTER //
// src/utils/errorMessages.vue